import {createApp} from 'vue'
import Vuex from "vuex";
import App from '@/customer/App.vue'
import router from '@/router/'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from "@/customer/store/index"
import storePanel from "@/panel/store/index"
import storeAgent from "@/agent/store/index"
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import config from "@/../config/config.json";
import ('@/panel/assets/fonts/fontawesome-free/css/all.min.css')
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
///main sass
import mainPanel from '@/panel/assets/css/main.sass'
import main from './customer/assets/css/panel/main.scss'
import mainAgent from './agent/assets/css/main.scss'
import "@/agent/assets/js/dashboard.js"
///css
import BootstrapVue3 from 'bootstrap-vue-3'


import '@/common/css/index.css'
import ("@/customer/assets/css/reset.css")
import ("@/customer/assets/css/panel/admin.css")

import ('bootstrap/dist/css/bootstrap.css')
import 'bootstrap';
import ('bootstrap/dist/js/bootstrap.bundle.js')

import ('bootstrap-vue-3/dist/bootstrap-vue-3.css')


import ("@/panel/assets/css/admin.css")
import ("@/panel/assets/js/main")

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'

axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, PUT, POST, DELETE, OPTIONS, post, get';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'X-Requested-With';
axios.defaults.baseURL = config.BASE_URL
const options = {
    // You can set your default options here
};
const app = createApp(App)
app.use(BootstrapVue3)
app.use(VueAxios, axios)
app.use(Toast, options);
app.use(Vuex)
app.use(main)
app.use(mainPanel)
app.use(mainAgent)
app.use(router)
app.use(store)
app.use(storePanel)
app.use(storeAgent)
app.use(VueSweetalert2);
app.mount('#app')
